import { useNavigationState } from '../../../navigation';

/**
 * Check if change request panel should be collapsed.
 */
export function useChangeRequestSidePanelCollapsed() {
    const { screen, overlay } = useNavigationState();
    const spaceScreen =
        overlay?.type === 'space' ? overlay : screen.type === 'space' ? screen : null;

    if (!spaceScreen?.sideSheet) {
        return false;
    }

    return spaceScreen.sideSheet.type !== 'comments' || spaceScreen.sideSheet.context !== 'preview';
}
